import axios from "axios";
import cookie from "react-cookies";
import { message } from "antd";
import { getTranslatedValue, logout, useLogout } from "./Utils";

// Custom axios
const CAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  validateStatus: (status) => status < 400,
  withCredentials: true,
});

CAxios.interceptors.request.use((config) => {
  if (config.url.startsWith("/api/")) {
    config.headers = config.headers || {};
  }
  return config;
});

CAxios.interceptors.response.use(null, function (error) {
  if (
    (error.response && error.response.status === 401) ||
    (error.response && error.response.status == 460)
  ) {
    useLogout();
  }

  if (error.response && error.response.status === 500) {
    message.error({
      content: getTranslatedValue("somethingWrong"),
    });
  }
  return Promise.reject(error);
});

export default CAxios;
